import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./components/HomePage";
import Dashboard from "./components/Dashboard";
import Settings from "./components/Settings";
import ArrivalBoard from "./components/ArrivalBoard";
import "./App.css";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/:pageId/edit" element={<Settings />} />
        <Route path="/:pageId" element={<ArrivalBoard />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
